const CONDITION_DISPLAY = { Mint: 'Like New', Broken: 'Spares or Repair' }
const CONDITION_VALUE = { 'Like New': 'Mint', 'Spares or Repair': 'Broken' }

export const displayCondition = v => (v && CONDITION_DISPLAY[v]) || v
export const valueFromDisplay = d => (d && CONDITION_VALUE[d]) || d
